import { ChecklistState } from './types'
import { createSlice } from '@reduxjs/toolkit'
import { checklistData } from './checklist.services';

export const initialState: ChecklistState = {
    data: {} as any,
    status: "loading",
    error: {}
}

export const ChecklistSlice = createSlice({
    name: 'checklist',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(checklistData.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(checklistData.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(checklistData.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
    }
})

export const OrderReducer = ChecklistSlice.reducer